
import { pointOnFeature } from "@turf/point-on-feature";
import { getConfig } from "configuration/config";

export type StringMap = Record<string, string | number | boolean>;

export function objectToQueryString(params: StringMap = {}): string {
    let queryString = "";
    Object.keys(params).forEach((key) => {
        if (queryString.length !== 0) queryString += "&";
        queryString += key + "=" + params[key].toString();
    });
    return queryString;
}


export function debounce<T extends (...args: any[]) => ReturnType<T>>(
    callback: T,
    timeout: number
): ((...args: Parameters<T>) => void) {
    let timer: ReturnType<typeof setTimeout>

    return (...args: Parameters<T>) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            callback(...args)
        }, timeout)
    }
}


/**
 * Check if input is an Object
 */
export function isObject(input: unknown): input is Record<string, unknown> {
    return typeof input === 'object' && input !== null && !Array.isArray(input);
}
/**
 * Merge the source object into the target like `Object.assign` but recursively.
 * No override if key already exist in target.
 */
export function merge<T extends Record<string, any>, S extends Record<string, any>>(target: T, source: S): T & S;
export function merge<T extends any, S extends any>(target: T, source: S): T | S;
export function merge(target: unknown, source: unknown): any {
    if (!isObject(source) || !isObject(target)) {
        return target;
    }
    for (const key in source) {
        const targetProp = target[key];
        const sourceProp = source[key];

        if (isObject(sourceProp) && isObject(targetProp)) {
            merge(targetProp, sourceProp);
        } else if (!(key in target)) {
            target[key] = source[key];
        }
    }
    return target;
}

/**
 * replace all keys enclosed by curly braces (eg. {replace_str}) by given values
 */
export function replace(str: string, keyValues: Record<string, string>): string {
    let result = str;
    Object.keys(keyValues).forEach((key) => {
        result = result.replace(
            new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'),
            keyValues[key]
        );
    });
    return result;
}
export function getFeaturePosition(feature: any): woosmap.map.LatLngLiteral {
    let position: woosmap.map.LatLngLiteral = { lat: 0, lng: 0 };
    if (feature && feature.geometry && feature.geometry.type === 'Polygon') {
        const center = pointOnFeature(feature);
        position = {
            lat: center.geometry.coordinates[1],
            lng: center.geometry.coordinates[0]
        }
    }
    else if (feature && feature.geometry && feature.geometry.type === 'Point') {
        position = { lat: feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0] }
    }
    return position;
}
export function showToast(message: string, type: 'success' | 'error') {
    const container = document.getElementById("woos-toast-container");
    if (!container) return;
    const existingToast = container.querySelector(`.woos-toast.${type}`);
    if (existingToast) {
        return;
    }

    const toast = document.createElement("div");
    toast.className = `woos-toast ${type}`;
    toast.textContent = message;

    container.appendChild(toast);

    setTimeout(() => {
        toast.remove();
    }, 4500);
}
export function displayBuilding(building: string): string {
    if (building === "C.SO+ITALIA") return "Corso Italia";
    return building;
}
export function isMobileView(): boolean {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width < getConfig().map.mobileBreakPoint) {
        return true;
    }
    return false;
}
export function computePaddingForPOIPanel(isMobile=false) {
    const defaultPadding = {
        top: 0, bottom: 0, left: 0, right: 0
    };
    let panelHeight = 0;
    let panelWidth = 0;
    const headerContent = document.getElementsByClassName("woosmap-panel__content__header")[0];
    const bodyContent = document.getElementsByClassName("woosmap-panel__content__body")[0];
    const searchBarContainer = document.getElementsByClassName("woosmap-panel__header")[0];

    if (searchBarContainer && headerContent && bodyContent) {
        panelHeight = headerContent.clientHeight + bodyContent.clientHeight + searchBarContainer.clientHeight;
        panelWidth = searchBarContainer.clientWidth;
    }
    panelHeight = isMobile ? 0 : panelHeight;
    if (isMobileView()) {
        defaultPadding.bottom = panelHeight;
    }
    else {
        defaultPadding.left = panelWidth;
    }
    return defaultPadding;
}